import { Select } from '@mantine/core';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { TableConfig } from 'models/general';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BsFillCaretDownFill } from 'react-icons/bs';
import { MultiSelect, Option } from 'react-multi-select-component';
import { queryParams } from 'utils/query';
import classes from 'global.module.css';

interface Props {
  choices: Option[];
  config: TableConfig;
  multiSelect?: boolean;
}
export const FilterStatus = ({ choices, config, multiSelect = false }: Props) => {
  const { setParameters, parameters: filters } = useSearchParameters(config.queryKey);
  const { t } = useTranslation();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    if (!filters.status && config?.defaultFilters?.[queryParams.status]) {
      setParameters({ ...filters, [queryParams.status]: config.defaultFilters[queryParams.status] });
    }
  }, [filters, config, setParameters]);

  const filteredGroups: Option[] = filters.status
    ? choices.filter((status) => filters.status?.split(',').includes(status.value))
    : [];

  const handleStatusChange = (option: Option[]) => {
    setParameters({ ...filters, [queryParams.status]: [option.map((group) => group.value)].join(',') });
  };

  if (multiSelect) {
    return (
      <MultiSelect
        className={classes.multiSelector}
        options={choices}
        value={filteredGroups}
        onChange={handleStatusChange}
        labelledBy={'status'}
        hasSelectAll={false}
        overrideStrings={{
          allItemsAreSelected: t('all_selected_label'),
          selectSomeItems: t('status_table_heading'),
        }}
        disableSearch={true}
        ArrowRenderer={() => <BsFillCaretDownFill color={'var(--mantine-color-default-border)'} />}
        ClearIcon={undefined}
      />
    );
  }

  return (
    <Select
      placeholder={t('status_table_heading')}
      data={choices}
      onChange={(value) => value && setParameters({ ...filters, [queryParams.status]: value })}
      value={filters[queryParams.status] || config?.defaultFilters?.[queryParams.status]}
      data-testid={'status-selector'}
    />
  );
};
